/**
 * channelsChoice component.
 */
import ChannelsChoiceTemplate from '../../templates/channel/channelsChoice';

export default function ChannelsChoicePage() {
  return <ChannelsChoiceTemplate />;
}
